var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts",attrs:{"id":"bar-chart"}},[_c('VueApexCharts',{attrs:{"type":"rangeBar","options":_vm.options,"series":_vm.series,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }